import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchAttendanceLeaveType, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchExtraHoursReport, fetchForm34ReportRequest, fetchForm6ReportRequest, fetchLeaveBalanceReportRequest, fetchLeaveReportRequest, getMobilePunchReport, resetAttendanceReport } from "store/actions";
import Loader from "common/pageLoader";
import CustomYearPicker from "common/CustomYearPicker";

const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
  { label: "Foreman", value: "Foreman" },
];
const yearOptions = [
  { label: "2024", value: "2024" },
  { label: "2025", value: "2025" },

]

const data = [
  { sno: 1, code: "0", name: "AES ADMIN", holiday1: "H", holiday2: "H", holiday3: "H", holiday4: "H", holiday5: "H", holiday6: "H", holiday7: "H", holiday8: "H", holiday9: "H" },
  { sno: 2, code: "001", name: "ARUN", holiday1: "H", holiday2: "H", holiday3: "H", holiday4: "H", holiday5: "H", holiday6: "H", holiday7: "H", holiday8: "H", holiday9: "H" },
  { sno: 3, code: "002", name: "VIGNESH", holiday1: "H", holiday2: "H", holiday3: "H", holiday4: "H", holiday5: "H", holiday6: "H", holiday7: "H", holiday8: "H", holiday9: "H" },
  { sno: 4, code: "003", name: "ULAGURAJ", holiday1: "H", holiday2: "H", holiday3: "H", holiday4: "H", holiday5: "H", holiday6: "H", holiday7: "H", holiday8: "H", holiday9: "H" },
  { sno: 5, code: "00320", name: "NAVEEN", holiday1: "-", holiday2: "-", holiday3: "-", holiday4: "-", holiday5: "-", holiday6: "-", holiday7: "-", holiday8: "-", holiday9: "-" },
];

const AttendanceReportForm6 = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    categories,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.AttendanceReportReducer?.employeeReport ?? [],
    categories: state.CategoryMaster?.categories ?? [],

    loading: state.AttendanceReportReducer?.loading,
    error: state.AttendanceReportReducer?.error,
    success: state.AttendanceReportReducer?.success,
  }));

  useEffect(() => {
    dispatch(resetAttendanceReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      category: "",
      year: null,
    },
    validationSchema: Yup.object({
      year: Yup.string()
        .nullable()
        .required("Year is required"),
    }),
    onSubmit: (values) => {
      // console.log("Form Values:", values);
      const formData = new FormData();
      formData.append("cat_id", values.category || 0);
      formData.append("year", values.year || "");
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);

      dispatch(fetchForm6ReportRequest(formData));
    },
  });

  // const columns = [
  //   { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", },
  //   { Header: "Code", accessor: "emp_code" },
  //   { Header: "Name", accessor: "emp_name" },
  //   { Header: "HAPPY DAYHolidayHolidayAppend 30.04.24", accessor: "holiday1" },
  //   { Header: "May Day 01.05.24", accessor: "holiday2" },
  //   { Header: "Independence Day 15.08.24", accessor: "holiday3" },
  //   { Header: "WORLD 15.08.24", accessor: "holiday4" },
  //   { Header: "Vinayaka Chaturthi 07.09.24", accessor: "holiday5" },
  //   { Header: "Gandhi Jayanthi 02.10.24", accessor: "holiday6" },
  //   { Header: "Deepavali 31.10.24", accessor: "holiday7" },
  //   { Header: "Ayutha Pooja 10.11.24", accessor: "holiday8" },
  // ];

  // Basic columns - fixed
  const basicColumns = [
    {
      Header: "S.No",
      Cell: ({ row }) => employeeReport.length - row.index,
      className: "serial-no text-center",
    },
    { Header: "Code", accessor: "emp_code" },
    { Header: "Name", accessor: "emp_name" },
  ];

  // Get dynamic holiday keys
  const firstRecord = employeeReport?.[0] || {};

  const dynamicColumns = Object.keys(firstRecord)
    .filter(key =>
      !["s_no", "emp_code", "emp_name"].includes(key) // exclude basic fields
    )
    .map(key => ({
        Header: key,
        accessor: String(key),
        Cell: ({ row }) => row.original?.[key] ?? "-", 
        className: "desc-col",
        applyHeaderClass: true
    }));

  // Final Columns
  const columns = [...basicColumns, ...dynamicColumns];


  const handleReset = () => {
      formik.resetForm(); 
      dispatch(resetAttendanceReport()); 
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Form 6" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={3}>
                  <Label>Category</Label>
                  <CustomSelect
                    id="category"
                    name="category"
                    options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                    value={
                      categories
                        .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                        .find(cat => cat.value === formik.values.category) || null
                    }
                    onChange={val => formik.setFieldValue('category', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                  />
                </Col>   
                <Col md={3}>
                  <Label>Year <span className="text-danger">*</span></Label>
                  <CustomYearPicker
                    value={formik.values.year || null}
                    onChange={(val) => formik.setFieldValue("year", val)}
                  />
                  {formik.touched.year && formik.errors.year ? (
                    <div className="text-danger">{formik.errors.year}</div>
                  ) : null}
                </Col>
                <Col className="d-flex mob-center align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2 mt-2" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-2">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Form6 Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Form6 Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}  
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>            
            <TableContainer
              columns={columns}
              data={employeeReport}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportForm6;
